export default class Local {
    static set (name, value) {
        let timestamp = Local.timestamp()
        localStorage.setItem(name, JSON.stringify(value))
        localStorage.setItem('timestamp', timestamp)
    }

    static get (name) {
        let timestamp = Local.timestamp()
        let localTimestamp = localStorage.getItem('timestamp')
        let data = localStorage.getItem(name)
        if (!data) {
            return null
        }
        if (timestamp - localTimestamp > process.env.EXPIRE) {
            Local.unset(name)
            return null
        }
        return JSON.parse(data)
    }

    static timestamp () {
        return parseInt(Date.parse(new Date()) / 1000)
    }

    static unset (name) {
        Local.set(name, null)
    }

    static hasUser (userId) {
        const users = Local.get('users')
        return userId === users['user_id']
    }

    static isLogin () {
        return Local.get('users') !== 'undefined' && Local.get('users') !== null
    }

    static getUser () {
        if (Local.isLogin()) {
            return Local.get('users')
        }
        return null
    }

    static getUserId () {
        if (Local.isLogin()) {
            return Local.getUser()['user_id']
        }
        return null
    }

    static getUserToken () {
        if (Local.isLogin()) {
            return Local.getUser()['token']
        }
        return null
    }
}



// WEBPACK FOOTER //
// ./src/lib/Local.js